import { render, staticRenderFns } from "./OvercomeDifficulties.vue?vue&type=template&id=28b15a78&scoped=true&"
import script from "./OvercomeDifficulties.vue?vue&type=script&lang=js&"
export * from "./OvercomeDifficulties.vue?vue&type=script&lang=js&"
import style0 from "./OvercomeDifficulties.vue?vue&type=style&index=0&id=28b15a78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b15a78",
  null
  
)

export default component.exports